import $ from 'jquery';

$(document).ready(function () {

	$(document).on(
		'click',
		'#language-switcher-button a, #billing_country_select_field, a.language-switcher',
		function (e) {
			e.preventDefault();
			$('#language-switcher').toggle();
		},
	);

	$('#close-lang').on('click', function (e) {
		e.preventDefault();
		$('#language-switcher').toggle();
	});


	$(document).on(
		'click',
		'#language-switcher ul li a',
		function (e) {
			if($(this).attr('href') === '#') {
				e.preventDefault();
				$('#language-switcher').toggle();
			}
		},
	);



});
